import React, { useState } from 'react';
import UnlockWithCoreUpsellModal, {
  Props as UnlockWithCoreUpsellModalProps,
} from './UnlockWithCoreUpsellModal';

export interface UnlockWithCoreUpsellModalReturn {
  modal: React.ReactNode;
  showModal: () => void;
}

export function useUnlockWithCoreUpsellModal(
  options: Omit<UnlockWithCoreUpsellModalProps, 'requestClose'>
): UnlockWithCoreUpsellModalReturn {
  const [showModal, setShowModal] = useState(false);
  const requestClose = () => setShowModal(false);

  const modal = showModal ? (
    <UnlockWithCoreUpsellModal requestClose={requestClose} {...options} />
  ) : null;

  return {
    showModal: () => setShowModal(true),
    modal,
  };
}
